<template>
  <div class="t-deal">
    <UBadge color="red" size="lg" class="mb-2">{{
      $t('components.deal.percentage', percentage)
    }}</UBadge>

    <TText classes="mt-0 mb-1" variant="semibold" clamp="clamp1">{{
      title
    }}</TText>

    <TText size="sm" classes="mt-0 mb-1">
      {{ $t('components.deal.nights', nights) }}
      {{
        $t('components.deal.dates', {
          dateIn: dateIn,
          dateOut: dateOut,
        })
      }}
    </TText>

    <TText size="sm" classes="mt-0 mb-1">
      {{ $t('components.deal.people', people) }}
      {{
        $t('components.deal.pricePersonNight', {
          pricePersonNight: pricePersonNight,
        })
      }}
    </TText>

    <TText size="sm" classes="mt-0 mb-4">
      <strong>{{ $t('components.deal.total', { total: total }) }}</strong>
      {{ $t('components.deal.totalOld', { totalOld: totalOld }) }}
    </TText>

    <UAccordion
      ref="accordionRef"
      :items="items"
      color="gray"
      variant="link"
      size="md"
    >
      <template #accordion-detail>
        <TText size="sm" classes="mt-0 mb-4">
          <span v-html="description" />

          <br />

          <strong>{{ $t('components.deal.whatIncludes') }}</strong>

          <span v-html="whatIncludes" />
        </TText>

        <UButton
          variant="concrete"
          :label="$t('components.deal.button')"
          rel="nofollow"
          :to="goToCottageContactDeal"
          external
        />
      </template>
    </UAccordion>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

export interface Props {
  title: string
  description: string

  percentage: number
  whatIncludes: string

  total: string
  totalOld: string

  dateIn: string
  dateOut: string

  nights: number
  people: number

  pricePersonNight: string

  slug: string
  province: string
  id: string
}

const props = defineProps<Props>()

const accordionRef = ref()

const textClose = t('components.deal.close')
const textOpen = t('components.deal.open')

const getLabel = computed(() => {
  if (accordionRef.value === undefined) {
    return textClose
  } else {
    return accordionRef.value.buttonRefs[0].open ? textOpen : textClose
  }
})

const items = reactive([
  {
    label: getLabel,
    defaultOpen: false,
    slot: 'accordion-detail',
    padded: false,
  },
])

const goToCottageContactDeal = routes().cottageContactDeal({
  slug: props.slug,
  province: props.province,
  id: props.id,
})
</script>
